import sampelCard2 from "../../../../Assets/sample-thumbnail-2.png";
import React, { useEffect, useState } from "react";
import "./MyPromotions.scss";
import { Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import {
  getInfluencerInvitation,
  getInfluencerInvitationClient,
} from "../../../../Services/prod/auth.service";
import { useAuth } from "../../../../Contexts/auth.context";
import Loading from "../../../../components/loading/loading.component";
import { CMAuctions } from "../../../Public/billing-history/billing-history.styles";
import ReactPaginate from "react-paginate";
import moment from "moment";
import PromotionsCard from "./PromotionsCard";

const MyPromotions = ({ activeTab }) => {
  // =============== STATES ===============
  const limitPending = 3;
  const limitHistory = 10;
  const limitInProgress = 3;
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [loadingInProgress, setLoadingInProgress] = useState(false);
  const [loadingPending, setLoadingPending] = useState(false);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [promotionsPending, setPromotionsPending] = useState({
    rows: [],
    count: 0,
  });
  const [promotionsInProgress, setPromotionsInProgress] = useState({
    rows: [],
    count: 0,
  });
  const [promotionsHistory, setPromotionsHistory] = useState({
    rows: [],
    count: 0,
  });

  const cards = [
    {
      type: "in-progress",
      title: "In Progress",
      data:
        promotionsInProgress &&
        promotionsInProgress?.rows?.map((item) => ({
          name: item?.name,
          artist: item?.ownerName || "N/A",
          thumbnail: item?.imgSrc?.[0] || sampelCard2,
          auctionStartDate: item?.startDate,
          auctionEndDate: item?.endDate,
          exclusive: true,
          live: item?.final_status === "InProgress" ? true : false,
          price: `$${item?.total_earning}`,
          id: item?.id,
          invitationData: {
            invitation_id: item?.invitation_id,
            invitation_date: item?.invitation_date,
            invitation_status: item?.status,
          },
          auctionCommision: item?.fee,
          auctionStatus: item?.final_status,
        })),
    },
    {
      type: "pending-invites",
      title: "Pending Invites",
      data:
        promotionsPending &&
        promotionsPending?.rows?.map((item) => ({
          name: item.name,
          artist: item.ownerName || "N/A",
          thumbnail: item?.imgSrc?.[0] || sampelCard2,
          scheduled: item?.startDateStr,
          id: item?.id,
          invitationData: {
            invitation_id: item?.invitation_id,
            invitation_date: item?.invitation_date,
            invitation_status: item?.status,
          },
          auctionCommision: item?.fee,
          auctionStatus: item?.final_status,
          auctionStartDate: item?.startDate,
          auctionEndDate: item?.endDate,
        })),
    },
  ];
  const handleInProgress = async (page) => {
    try {
      setLoadingInProgress(true);
      const resInvitationList = await getInfluencerInvitation(
        page || 1,
        limitInProgress,
        search,
        "ACCEPTED"
      );
      if (
        resInvitationList?.status === 200 ||
        resInvitationList?.status === 201
      ) {
        const promotions = resInvitationList?.data?.rows;
        const auctionIds = promotions
          ?.map((data) => data?.auction_id)
          .join(",");
        const clientPayload = {
          cmd: "iAuction_influencerflow",
          UserId: auth.userId,
          auctioninfluencerflow_array: auctionIds,
        };
        const resClient = await getInfluencerInvitationClient(clientPayload);
        if (resClient) {
          const mergedPromotions = promotions?.map((promotion) => {
            const clientData = resClient?.find(
              (client) => client?.id === promotion?.auction_id
            );
            return { ...promotion, ...clientData };
          });
          setPromotionsInProgress({
            rows: mergedPromotions,
            count: resInvitationList?.data?.count,
          });
          setLoadingInProgress(false);
        }
      } else {
        console.log("***** ERROR IN API *****", resInvitationList?.message);
        setLoadingInProgress(false);
      }
    } catch (error) {
      setLoadingInProgress(false);
      console.log(error, "error");
    }
  };
  const handlePending = async (page) => {
    try {
      setLoadingPending(true);
      const resInvitationList = await getInfluencerInvitation(
        page || 1,
        limitPending,
        search,
        "PENDING"
      );
      if (
        resInvitationList?.status === 200 ||
        resInvitationList?.status === 201
      ) {
        const promotions = resInvitationList?.data?.rows;
        const auctionIds = promotions
          ?.map((data) => data?.auction_id)
          .join(",");
        const clientPayload = {
          cmd: "iAuction_influencerflow",
          UserId: auth?.userId,
          auctioninfluencerflow_array: auctionIds,
        };
        const resClient = await getInfluencerInvitationClient(clientPayload);
        if (resClient) {
          const mergedPromotions = promotions?.map((promotion) => {
            const clientData = resClient?.find(
              (client) => client?.id === promotion?.auction_id
            );
            return { ...promotion, ...clientData };
          });
          setPromotionsPending({
            rows: mergedPromotions,
            count: resInvitationList?.data?.count,
          });
          setLoadingPending(false);
        }
      } else {
        console.log("***** ERROR IN API *****", resInvitationList?.message);
        setLoadingPending(false);
      }
    } catch (error) {
      setLoadingPending(false);
      console.log(error, "error");
    }
  };
  const handleHistory = async (page) => {
    try {
      setLoadingHistory(true);
      const resInvitationList = await getInfluencerInvitation(
        page || 1,
        limitHistory,
        search,
        ""
      );
      if (
        resInvitationList?.status === 200 ||
        resInvitationList?.status === 201
      ) {
        setPromotionsHistory({
          rows: resInvitationList?.data?.rows,
          count: resInvitationList?.data?.count,
        });
        setLoadingHistory(false);
      }
    } catch (error) {
      setLoadingHistory(false);
      console.log(error, "error");
    }
  };

  useEffect(() => {
    if (activeTab === "my-promotions") {
      handleInProgress();
      handlePending();
      handleHistory();
    }
  }, [activeTab]);

  // *********** HANDLE PAGE {PENDING} ***********
  const handlePagePending = ({ selected }) => {
    handlePending(selected + 1);
  };

  // *********** HANDLE PAGE {IN-PROGRESS} ***********
  const handlePageInprogress = ({ selected }) => {
    handleInProgress(selected + 1);
  };

  // *********** HANDLE PAGE {HISTORY} ***********
  const handlePageHistory = ({ selected }) => {
    setPage(selected + 1);
    handleHistory(selected + 1);
  };

  // *********** INFLUENCER NAVIGATION PROMOTIONS ***********
  const handleNavigate = (data) => {
    const detailData = {
      invitationData: {
        invitation_status: data?.status,
        invitation_id: data?.invitation_id,
        invitation_date: data?.invitation_date,
      },
      auctionCommision: data?.fee,
    };
    navigate(`/influncer-analytics?auctionId=${data?.auction_id}`, {
      state: detailData,
    });
  };

  return (
    <div className="my_promotions">
      <div className="my_promotions_lists">
        <div className="my_promotions_list">
          <h3>{"Accepted Invites"}</h3>
          {loadingInProgress ? (
            <div className="promotions_loading">
              <Loading />
            </div>
          ) : (
            <PromotionsCard data={cards[0].data} type="in-progress" />
          )}
        </div>
        {promotionsInProgress?.count > limitInProgress && (
          <CMAuctions>
            <section className="pagination custom_pagination">
              <ReactPaginate
                breakLabel="..."
                nextLabel=""
                previousLabel=""
                onPageChange={handlePageInprogress}
                pageRangeDisplayed={3}
                pageCount={Math.ceil(
                  promotionsInProgress?.count / limitInProgress
                )}
                renderOnZeroPageCount={null}
              />
            </section>
          </CMAuctions>
        )}
        <div className="my_promotions_list">
          <h3>{"Pending Invites"}</h3>
          {loadingPending ? (
            <div className="promotions_loading">
              <Loading />
            </div>
          ) : (
            <PromotionsCard data={cards[1].data} type="pending-invites" />
          )}
        </div>
        {promotionsPending?.count > limitPending && (
          <CMAuctions>
            <section className="pagination custom_pagination">
              <ReactPaginate
                breakLabel="..."
                nextLabel=""
                previousLabel=""
                onPageChange={handlePagePending}
                pageRangeDisplayed={3}
                pageCount={Math.ceil(promotionsPending?.count / limitPending)}
                renderOnZeroPageCount={null}
              />
            </section>
          </CMAuctions>
        )}
      </div>
      {loadingHistory ? (
        <div className="promotions_loading">
          <Loading />
        </div>
      ) : (
        <div className="history_sec">
          <hr className="custom_hr" />
          <div className="history_box">
            <h3>History</h3>
            <Table responsive className="custom_table">
              <tbody>
                {promotionsHistory && promotionsHistory?.rows?.length > 0 ? (
                  promotionsHistory?.rows?.map((data) => (
                    <tr>
                      <td>
                        {data?.status === "ACCEPTED" ? (
                          <p
                            style={{ color: "#329bc9", cursor: "pointer" }}
                            onClick={() => handleNavigate(data)}
                          >
                            {data?.auction_name}
                          </p>
                        ) : (
                          <p
                            style={{ color: "#329bc9", cursor: "pointer" }}
                            onClick={() => handleNavigate(data)}
                          >
                            {data?.auction_name}
                          </p>
                        )}
                      </td>
                      <td>
                        {moment(data?.auction?.start_date)
                          .tz("EST")
                          .format("DD/MM/YYYY")}
                      </td>
                      <td>
                        <button
                          type="button"
                          className={
                            data?.status === "ACCEPTED"
                              ? "accept_btn"
                              : "reject_btn"
                          }
                        >
                          {data?.status === "ACCEPTED" ? "ACCEPT" : "REJECT"}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <p>No records Found</p>
                )}
              </tbody>
            </Table>
            {promotionsHistory?.count > limitHistory && (
              <CMAuctions>
                <section className="pagination custom_pagination">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel=""
                    previousLabel=""
                    onPageChange={handlePageHistory}
                    pageRangeDisplayed={3}
                    pageCount={Math.ceil(
                      promotionsHistory?.count / limitHistory
                    )}
                    renderOnZeroPageCount={null}
                    forcePage={page - 1}
                  />
                </section>
              </CMAuctions>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MyPromotions;
